import RemoveButton from '@theme/components/atom/RemoveButton'

export default {
  components: { RemoveButton },
  props: {
    IconOnRight: {
      type: Boolean,
      default() {
        return this.$themeSettings.components.EmptyCart.iconOnRight
      },
    },
  },
  methods: {
    async emptyCart() {
      this.$refs.emptyCart.startLoading()
      await this.$store.dispatch('cart/EMPTY_CART')
      if (this.$refs.emptyCart) this.$refs.emptyCart.stopLoading()
    },
  },
}
